import React, { useEffect, useState } from "react";
import storeData from "./AboutData.json";
import Marquee from "react-fast-marquee";

const About = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  return (
    <div className=" lg:h-[744px] flex flex-col gap-14 justify-center items-center px-4">
      <div className="lg:w-auto w-[361px]  flex flex-col gap-4 leading-[150%] justify-center items-center text-center">
        <h2 className="font-semibold lg:text-4xl text-[28px] leading-[150%] text-[#364763]">
          Own a store? Deliver effortlessly with Flit
        </h2>
        <h5 className="font-medium lg:text-xl text-base text-[#606C80] lg:w-auto w-[270px]">
          Any business, any product - Reach customers or friends in minutes
        </h5>
      </div>
      <div className="hidden lg:flex w-[1194px] gap-6 flex-wrap justify-center">
        {storeData.map((data) => (
          <div
            id={data.is}
            className="w-[232px] h-[236px] flex flex-col px-[10px] pt-[10px] pb-6 rounded-2xl border-[0.66px] border-opacity-10 border-[#124DAB] justify-center items-center gap-[18px]"
          >
            <span className="flex justify-center items-center w-[212px] h-[160px] rounded-lg overflow-hidden">
              <img src={data.Image} alt="" />
            </span>
            <h5 className="text-base text-[#4D4C66] font-semibold">
              {data.name}
            </h5>
          </div>
        ))}
      </div>

      {isMobile && (
        <Marquee
          speed={30}
          direction="right"
          gradient={true}
          gradientWidth={30}
        >
          <div className="flex lg:hidden gap-6 ">
            {storeData.map((data) => (
              <div
                id={data.is}
                className="w-[148px] h-[151px] flex flex-col px-[10px] pt-[10px] pb-6 rounded-2xl border-[0.66px] border-opacity-10 border-[#124DAB] justify-center items-center gap-[18px] last:mr-[24px]"
              >
                <span className="flex justify-center items-center w-[135px] h-[102px] rounded-lg overflow-hidden">
                  <img src={data.Image} alt="" />
                </span>
                <h5 className="text-[10px] text-[#4D4C66] font-semibold">
                  {data.name}
                </h5>
              </div>
            ))}
          </div>
        </Marquee>
      )}

      <h3 className="text-2xl text-[#606C80] font-medium">
        and so much more.....
      </h3>
    </div>
  );
};

export default About;
